// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1854":"246f0e98","2187":"246f0e98","2247":"246f0e98","7990":"246f0e98","9836":"246f0e98"}[chunkId] + ".chunk.css";
};